import { jwtDecode } from "jwt-decode";

export const getUserFromToken = (token) => {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

export const getTokenRemainingTime = (token) => {
  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000;
    return decoded.exp - now;
  } catch {
    return 0;
  }
};

export const isTokenExpired = (token) => {
  return getTokenRemainingTime(token) <= 0;
};
